import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import playerRankRecord from '@/components/playerRankRecord'
import Login from '@/components/login'
import message from '@/components/message'
import account from '@/components/user/account'
import record from '@/components/user/record'
import download from '@/components/download'
import messenger from '@/components/messenger'
import customer from '@/components/user/customer'
import online from '@/components/user/online'
import thalIndex from '@/components/THAL/index'
import ranking from '@/components/THAL/ranking'
import calendar from '@/components/THAL/calendar'
import thalRecord from '@/components/THAL/Record'
import bet2D from '@/components/THAL/bet2D'
import bet3D from '@/components/THAL/bet3D'
import recordsBet from '@/components/THAL/recordBet'
import record_list from '@/components/THAL/record_list'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path:'/playerRankRecord',
      name:'playerRankRecord',
      component:playerRankRecord
    },
    {
      path:'/Login',
      name:'Login',
      component:Login
    },
    {
      path:'/message',
      name:'message',
      component:message,
    },
    {
      path:'/account',
      name:'account',
      component:account,
    },
    {
      path:'/record',
      name:'record',
      component:record
    },
    {
      path:'/download',
      name:'download',
      component:download
    },
    {
      path:'/messenger',
      name:'messenger',
      component:messenger,
    },
    {
      path:'/online',
      name:'customer',
      component:customer,
    },
    {
      path:'/online/:id',
      name:'online',
      component:online
    },
    {
      path:'/THAL/index',
      name:'thalIndex',
      component:thalIndex
    },
    {
      path:'/THAL/ranking',
      name:'ranking',
      component:ranking,
    },
    {
      path:'/THAL/calendar',
      name:'calendar',
      component:calendar,
    },
    {
      path:'/THAL/Record',
      name:'thalRecord',
      component:thalRecord,
    },
    {
      path:'/THAL/bet2D',
      name:'bet2D',
      component:bet2D
    },
    {
      path:'/THAL/bet3D',
      name:'bet3D',
      component:bet3D
    },
    {
      path:'/THAL/recordBet',
      name:'recordsBet',
      component:recordsBet,
    },
    {
      path:'/THAL/record/list',
      name:'record_list',
      component:record_list
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js